import {
  HomeHero,
  ProblemSection,
  IncludedSection,
  IllinoisSection,
  QuestionCredibilitySection,
  AiCoachSection,
  PreviewSection,
  HowItWorksSection,
  PlatformAccessNote,
  TrustSection,
  FaqPreviewSection,
  FinalCtaSection,
} from "@/components/home/HomeSections";
import StickyMobileCta from "@/components/StickyMobileCta";
import VerifiedTestimonials from "@/components/VerifiedTestimonials";

export default function Home() {
  return (
    <div>
      <HomeHero />
      <ProblemSection />
      <IncludedSection />
      <IllinoisSection />
      <QuestionCredibilitySection />
      <AiCoachSection />
      <VerifiedTestimonials />
      <PreviewSection />
      <HowItWorksSection />
      <PlatformAccessNote />
      <TrustSection />
      <FaqPreviewSection />
      <FinalCtaSection />
      <StickyMobileCta source="home_sticky" />
    </div>
  );
}
